import { toast } from 'react-toastify';

const CHUNK_ERROR_PATTERN =
    /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed/i;

const RELOAD_AT_KEY = 'chunk_reloaded_at';
// Reload again only if the previous auto-reload was long enough ago, so a chunk
// that is genuinely missing cannot cause a reload loop.
const RELOAD_COOLDOWN_MS = 10_000;
// Give the user time to read the toast before the page reloads.
const RELOAD_DELAY_MS = 2000;

export const isChunkLoadError = (err: unknown): boolean => {
    if (!err) return false;
    const { name, message } = err as { name?: string; message?: string };
    return CHUNK_ERROR_PATTERN.test(`${name ?? ''} ${message ?? (typeof err === 'string' ? err : '')}`);
};

/**
 * Reloads the page once when a lazy chunk fails to load (stale tab after a deploy).
 * Returns true if a reload was triggered, false if the caller should show its error UI.
 */
export const reloadOnceForChunkError = (err: unknown): boolean => {
    if (!isChunkLoadError(err)) return false;
    try {
        const last = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
        if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;
        sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
    } catch {
        // sessionStorage unavailable: cannot guard against loops, so do not reload.
        return false;
    }
    toast.info('Trình duyệt sẽ được reload lại để cập nhật phiên bản mới', { autoClose: RELOAD_DELAY_MS });
    setTimeout(() => window.location.reload(), RELOAD_DELAY_MS);
    return true;
};

export const registerChunkErrorHandlers = () => {
    window.addEventListener('error', (e) => {
        reloadOnceForChunkError(e.error ?? e.message);
    });
    window.addEventListener('unhandledrejection', (e) => {
        reloadOnceForChunkError(e.reason);
    });
};
